import React from 'react';
import Header from '../components/Header/Header';
import Footer from '../components/Footer/Footer';
import './Pages.css';

function Career() {
  const currentPositions = [
    {
      title: "Kontabilist Senior",
      department: "Kontabilitet",
      type: "Kohë e Plotë",
      location: "Prishtinë",
      description: "Kërkojmë një kontabilist të përvojshëm për të bashkuar ekipin tonë të kontabilitetit.",
      requirements: [
        "Bachelor në Kontabilitet ose fushë të ngjashme",
        "5+ vjet përvojë në kontabilitet",
        "Njohuri të mira të softuerëve kontabiliteti",
        "Certifikim profesional (përparësi)",
        "Gjuhët: Shqip, Anglisht"
      ]
    },
    {
      title: "Konsulent Financiar",
      department: "Konsulencë",
      type: "Kohë e Plotë",
      location: "Prishtinë",
      description: "Kërkojmë një konsulent financiar për të ofruar këshilla strategjike klientëve tanë.",
      requirements: [
        "Master në Financa ose MBA",
        "3+ vjet përvojë në konsulencë financiare",
        "Njohuri të mira të analizës financiare",
        "Aftësi të mira komunikimi",
        "Gjuhët: Shqip, Anglisht"
      ]
    }
  ];

  const benefits = [
    {
      title: "Rritje Profesionale",
      description: "Mundësi për zhvillim dhe avancim në karrierë"
    },
    {
      title: "Mësim i Vazhdueshëm",
      description: "Programe trajnimi dhe zhvillimi profesional"
    },
    {
      title: "Paketë Konkurruese",
      description: "Pagë konkurruese dhe përfitime të mira"
    },
    {
      title: "Mjedis i Mirë",
      description: "Mjedis pune pozitiv dhe bashkëpunues"
    }
  ];

  return (
    <div className="main-bg">
      <Header />
      <div className="page-container">
        <div className="page-header">
          <h1>Karriera</h1>
          <div className="page-bar"></div>
        </div>
        
        <div className="page-content">
          <div className="career-intro">
            <h2>Bashkohuni me Ekipin Tonë</h2>
            <p>Në ShalaAccounting, ne besojmë në zhvillimin e talenteve dhe ofrojmë mundësi për rritje profesionale. Nëse jeni të pasionuar për kontabilitetin dhe konsulencën biznesi, dëshirojmë të dëgjojmë nga ju.</p>
          </div>
          
          <div className="current-positions">
            <h2>Pozicionet e Hapura</h2>
            {currentPositions.map((position, index) => (
              <div key={index} className="position-card">
                <div className="position-header">
                  <h3>{position.title}</h3>
                  <div className="position-meta">
                    <span className="department">{position.department}</span>
                    <span className="type">{position.type}</span>
                    <span className="location">{position.location}</span>
                  </div>
                </div>
                <p className="position-description">{position.description}</p>
                <div className="position-requirements">
                  <h4>Kërkesat:</h4>
                  <ul>
                    {position.requirements.map((req, reqIndex) => (
                      <li key={reqIndex}>{req}</li>
                    ))}
                  </ul>
                </div>
                <button className="apply-btn">Apliko Tani</button>
              </div>
            ))}
          </div>
          
          <div className="career-benefits">
            <h2>Përfitimet e Punës</h2>
            <div className="benefits-grid">
              {benefits.map((benefit, index) => (
                <div key={index} className="benefit-card">
                  <h3>{benefit.title}</h3>
                  <p>{benefit.description}</p>
                </div>
              ))}
            </div>
          </div>
          
          <div className="career-contact">
            <h2>Kontaktoni Me Ne</h2>
            <p>Nëse nuk gjeni një pozicion të përshtatshëm, por dëshironi të bashkoheni me ekipin tonë, dërgoni CV-në tuaj në:</p>
            <div className="contact-info">
              <p><strong>Email:</strong> kariera@shalaaccounting.com</p>
              <p><strong>Telefon:</strong> +383 44 220 640</p>
              <p><strong>Adresa:</strong> Prishtinë, Kosovë</p>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Career; 